/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import autoBind from 'auto-bind';

import Analytics from './analytics/Analytics';

class LanguageController {
  private static _instance: LanguageController;

  public i18n: any;
  public t: any;

  constructor() {
    autoBind(this);
  }

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  public languages = ['en', 'de', 'fr', 'es', 'pt', 'it', 'sv', 'fi', 'jp', 'zh'];
  public languageName = (l: string) => this.t(`language.${l.slice(0, 2)}`);
  public languageNameShort = (l: string) => l.charAt(0).toUpperCase() + l.slice(1, 2);
  public isCurrentLanguage = (l: string) => this.i18n.language === l;
  public get currentLanguageName() {
    return this.languageName(this.i18n.language);
  }
  public get currentLanguageNameShort() {
    return this.languageNameShort(this.i18n.language);
  }
  public get currentLanguageIndex() {
    return this.languages.indexOf(this.i18n.language);
  }
  public get languageNames() {
    return this.languages.map((lng) => this.languageName(lng));
  }

  public changeLanguageByIndex(ind: number) {
    this.changeLanguage(this.languages[ind]);
  }

  public changeLanguage(l: string) {
    if (!this.languages.includes(l)) {
      Analytics.error('error.language', `Unknown language: ${l}`);
    }

    if (!this.isCurrentLanguage(l)) {
      this.i18n.changeLanguage(l);
      this.refreshLanguage();
      Analytics.log('settings.language', l);
    }
  }

  public refreshLanguage() {
    document.title = this.t('ui.title');
  }
}

export default LanguageController.instance;
